import { render, staticRenderFns } from "./GeneClassSymbolRegistration.vue?vue&type=template&id=31f9b35a&scoped=true"
import script from "./GeneClassSymbolRegistration.vue?vue&type=script&lang=js"
export * from "./GeneClassSymbolRegistration.vue?vue&type=script&lang=js"
import style0 from "./GeneClassSymbolRegistration.vue?vue&type=style&index=0&id=31f9b35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f9b35a",
  null
  
)

export default component.exports